/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {PartNumberChangesCreateNewComponent} from './part-number-changes-create-new.component';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';
import {CommonModule} from '@angular/common';
import {InputModule} from '../../shared/input/input.module';
import {PartNumberChangesCredentialsModule} from '../part-number-changes-credentials/part-number-changes-credentials.module';
import {PartNumberChangesOldCredentialsModule} from '../part-number-changes-old-credentials/part-number-changes-old-credentials.module';
import {PartNumberChangeDetailFooterModule} from '../part-number-changes-footer/part-number-change-detail-footer.module';
import {StatusTimelineModule} from '../../shared/status-timeline/status-timeline.module';

@NgModule({
    imports: [
        LoadingSpinnerModule,
        CommonModule,
        InputModule,
        PartNumberChangesCredentialsModule,
        PartNumberChangesOldCredentialsModule,
        PartNumberChangeDetailFooterModule,
        StatusTimelineModule
    ],
    declarations: [PartNumberChangesCreateNewComponent],
    exports: [PartNumberChangesCreateNewComponent]
})
export class PartNumberChangesCreateNewModule {
}
